import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import type { HotelDetailV2Model } from "../model/hotelDetailV2.model";

interface HotelIdentityProps {
  hotel: HotelDetailV2Model;
}

export default function HotelIdentity({ hotel }: HotelIdentityProps) {
  const locationLabel = hotel.address?.includes(hotel.city.name)
    ? hotel.address
    : [hotel.city.name, hotel.address].filter(Boolean).join("، ");

  return (
    <section
      aria-labelledby="hotel-detail-title"
      className="mb-4 flex items-start justify-between gap-4"
    >
      <div className="min-w-0">
        <h1
          id="hotel-detail-title"
          className="text-2xl font-extrabold leading-9 text-[#1a1a2e] md:text-3xl md:leading-10"
        >
          {hotel.name}
        </h1>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1.5">
          {hotel.stars > 0 ? (
            <span
              className="inline-flex items-center gap-0.5 text-amber-400"
              aria-label={`${hotel.stars} ستاره`}
            >
              {Array.from({ length: 5 }).map((_, index) => (
                <PhosphorIcon
                  key={index}
                  name="Star"
                  size={14}
                  weight="fill"
                  className={
                    index < hotel.stars ? "text-amber-400" : "text-slate-200"
                  }
                />
              ))}
            </span>
          ) : null}
          {locationLabel ? (
            <span className="flex min-w-0 items-start gap-1.5 text-sm leading-6 text-[#6b7280]">
              <PhosphorIcon
                className="mt-1 shrink-0 text-[#9ca3af]"
                name="MapPin"
                size={13}
              />
              <span>{locationLabel}</span>
            </span>
          ) : null}
        </div>
      </div>
      {/* TODO: Restore the desktop rating summary after reviews are connected to real data. */}
    </section>
  );
}
